import React, { useEffect } from 'react';
import './Services.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import PPC from '../../img/serv-ppc.jpg';

import './ServicesTop/ServicesTop.css';
import Blog from '../Blog/Blog';
import ServicesList from './ServicesList';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Ppc = () => {
    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, []);

    return (
        <>
            <Helmet>
                <meta name="fragment" content="!" />
                <title>
                    Pay Per Click Advertising - MediaFuse Agency
                </title>
                <meta
                    name="description"
                    content="Get your brand offerings in front of the right people at the right time with optimized pay per click services"
                />
                <link rel="canonical" href="https://mediafuseagency.com/pay-per-click" />
                <meta property="og:title" content="Pay Per Click Advertising - MediaFuse Agency" />
                <meta
                    property="og:description"
                    content="Get your brand offerings in front of the right people at the right time with optimized pay per click services"
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://mediafuseagency.com/pay-per-click" />
                <meta property="og:site_name" content="MediaFuse Agency" />

                <meta property="og:image" content="https://mediafuseagency.com/static/media/MFP.d57d3e5c53694bbedd86.jpg" />
                <meta property="og:image:secure_url" content="https://mediafuseagency.com/static/media/MFP.d57d3e5c53694bbedd86.jpg" />
                <meta property="og:image:type" content="image/jpg" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="fb:app_id" content="654497786394804" />

                <meta name="twitter:title" content="Pay Per Click Advertising - MediaFuse Agency" />
                <meta
                    name="twitter:description"
                    content="Get your brand offerings in front of the right people at the right time with optimized pay per click services"
                />
                <meta name="twitter:image" content="https://mediafuseagency.com/static/media/MFP.d57d3e5c53694bbedd86.jpg" />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            <div>
                <div className="services">
                    <div className="services-con">
                        <div>
                            <div className="services-top">
                                <div className="services-top-con b-fancy">
                                    <div className="services-top-con-div">
                                        <div className="stcd serv-div">
                                            <div className="stcd-right serv">
                                                <h1 className="serv-header">
                                                    Supercharge your brand reach with pay per click
                                                </h1>
                                                <p className='serv-body'>
                                                    In an ideal scenario, a combination of SEO and PPC strategies delivers optimal results in terms of driving targeted traffic, maximizing visibility, and providing long-term benefits.
                                                    Get your brand offerings in front of the right people at the right time with optimized pay per click services.

                                                </p>

                                                <Link to='//sales'>
                                                    <div className="gl-click-sm button-w">
                                                        <span className='gl-click-txt-sm'>Let's get started</span>
                                                        <span class="material-symbols-outlined in-left-arrow">
                                                            arrow_right_alt
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className="stcd-left">
                                                <img className="stcd-img no-b" src={PPC} alt='MediaFuse Agency Services' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ServicesList />
                        <Blog />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Ppc